<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      .icon.mt-5
        .icon-area
          .icon-success.mx-auto.text-center
            .success.mb-5
              .action
                .trophy.mx-auto
                  .circle.mt-3.mb-5
                    img(
                      :src='okImg',
                      alt='success_ok_img'
                    )
      p.text-center 恭喜您完成綁定
      .row.p-3.pt-5.mx-2
        .col-12
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="backToLINEHandler()"
          ) 返回官方帳號
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'saSuccess',
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
